import React from "react";
import feedBagPhotoIcon from "../feed-bag-photo-icon.png";
import { getNativeSafeAsset } from "./platformAssets";

const genericRationCardIcon = getNativeSafeAsset("/icons/shared/saco-racao-generico-card.webp");
const bovineRationCardIcon = getNativeSafeAsset("/icons/bovinos/saco-racao-bovinos-card.webp");
const sheepHeadCardIcon = getNativeSafeAsset("/icons/ovinos/cabeca-ovino-card.webp");
const bovineHeadCardIcon = getNativeSafeAsset("/icons/bovinos/cabeca-boi-card.webp");
const horseHeadCardIcon = getNativeSafeAsset("/icons/equinos/cabeca-cavalo-card.webp");
const equineRationCardIcon = getNativeSafeAsset("/icons/equinos/saco-racao-equinos-card.webp");
const troughCardIcon = getNativeSafeAsset("/icons/shared/cocho-racao-card.webp");
const chickenHeadCardIcon = getNativeSafeAsset("/icons/avicultura/cabeca-frango-card.webp");
const chickenLotsCardIcon = getNativeSafeAsset("/icons/avicultura/tres-frangos-lote-card.webp");
const grassClumpCardIcon = getNativeSafeAsset("/icons/shared/moita-capim-card.webp");
const weedGrassClumpCardIcon = getNativeSafeAsset("/icons/shared/moita-capim-erva-daninha-card.webp");

export function FeedBagIcon({ size = 20, style = {}, title = "Saco de ração" }){
  return (
    <img
      src={feedBagPhotoIcon}
      width={Math.round(size * 1.38)}
      height={Math.round(size * 1.38)}
      alt={title}
      title={title}
      draggable={false}
      style={{display:"inline-block",verticalAlign:"middle",flex:"0 0 auto",objectFit:"contain",...style}}
    />
  );
}


export function GenericRationBagIcon({ size = 20, style = {}, title = "Saco de ração" }){
  return (
    <img
      src={genericRationCardIcon}
      width={Math.round(size * 1.38)}
      height={Math.round(size * 1.38)}
      alt={title}
      title={title}
      draggable={false}
      loading="eager"
      decoding="async"
      style={{display:"inline-block",verticalAlign:"middle",flex:"0 0 auto",objectFit:"contain",...style}}
    />
  );
}


export function BovineRationBagIcon({ size = 20, style = {}, title = "Saco de ração bovino" }){
  return (
    <img
      src={bovineRationCardIcon}
      width={Math.round(size * 1.32)}
      height={Math.round(size * 1.32)}
      alt={title}
      title={title}
      draggable={false}
      loading="eager"
      decoding="async"
      style={{display:"inline-block",verticalAlign:"middle",flex:"0 0 auto",objectFit:"contain",...style}}
    />
  );
}

export function EquineRationBagIcon({ size = 20, style = {}, title = "Saco de ração equinos" }){
  return (
    <img
      src={equineRationCardIcon}
      width={Math.round(size * 1.32)}
      height={Math.round(size * 1.32)}
      alt={title}
      title={title}
      draggable={false}
      loading="eager"
      decoding="async"
      style={{display:"inline-block",verticalAlign:"middle",flex:"0 0 auto",objectFit:"contain",...style}}
    />
  );
}

export function SheepHeadIcon({ size = 20, style = {}, title = "Ovino" }){
  return (
    <img
      src={sheepHeadCardIcon}
      width={Math.round(size * 1.2)}
      height={Math.round(size * 1.2)}
      alt={title}
      title={title}
      draggable={false}
      loading="eager"
      decoding="async"
      style={{display:"inline-block",verticalAlign:"middle",flex:"0 0 auto",objectFit:"contain",...style}}
    />
  );
}


export function BovineHeadIcon({ size = 20, style = {}, title = "Bovino" }){
  return (
    <img
      src={bovineHeadCardIcon}
      width={Math.round(size * 1.2)}
      height={Math.round(size * 1.2)}
      alt={title}
      title={title}
      draggable={false}
      loading="eager"
      decoding="async"
      style={{display:"inline-block",verticalAlign:"middle",flex:"0 0 auto",objectFit:"contain",...style}}
    />
  );
}


export function TroughIcon({ size = 20, style = {}, title = "Cocho de ração" }){
  return (
    <img
      src={troughCardIcon}
      width={Math.round(size * 1.2)}
      height={Math.round(size * 1.2)}
      alt={title}
      title={title}
      draggable={false}
      loading="eager"
      decoding="async"
      style={{display:"inline-block",verticalAlign:"middle",flex:"0 0 auto",objectFit:"contain",...style}}
    />
  );
}


export function ChickenHeadIcon({ size = 20, style = {}, title = "Avicultura" }){
  return (
    <img
      src={chickenHeadCardIcon}
      width={Math.round(size * 1.2)}
      height={Math.round(size * 1.2)}
      alt={title}
      title={title}
      draggable={false}
      loading="eager"
      decoding="async"
      style={{display:"inline-block",verticalAlign:"middle",flex:"0 0 auto",objectFit:"contain",...style}}
    />
  );
}


export function ChickenLotsIcon({ size = 20, style = {}, title = "Lotes de aves" }){
  return (
    <img
      src={chickenLotsCardIcon}
      width={Math.round(size * 1.2)}
      height={Math.round(size * 1.2)}
      alt={title}
      title={title}
      draggable={false}
      loading="eager"
      decoding="async"
      style={{display:"inline-block",verticalAlign:"middle",flex:"0 0 auto",objectFit:"contain",...style}}
    />
  );
}


export function GrassClumpIcon({ size = 20, style = {}, title = "Locais" }){
  return (
    <img
      src={grassClumpCardIcon}
      width={Math.round(size * 1.18)}
      height={Math.round(size * 1.18)}
      alt={title}
      title={title}
      draggable={false}
      loading="eager"
      decoding="async"
      style={{display:"inline-block",verticalAlign:"middle",flex:"0 0 auto",objectFit:"contain",...style}}
    />
  );
}

export function WeedGrassClumpIcon({ size = 20, style = {}, title = "Sujos/Muito Sujos" }){
  return (
    <img
      src={weedGrassClumpCardIcon}
      width={Math.round(size * 1.18)}
      height={Math.round(size * 1.18)}
      alt={title}
      title={title}
      draggable={false}
      loading="eager"
      decoding="async"
      style={{display:"inline-block",verticalAlign:"middle",flex:"0 0 auto",objectFit:"contain",...style}}
    />
  );
}

export function HorseIcon({ size = 20, style = {}, title = "Cavalo" }){
  return (
    <img
      src={horseHeadCardIcon}
      width={Math.round(size * 1.613)}
      height={Math.round(size * 1.613)}
      alt={title}
      title={title}
      draggable={false}
      loading="eager"
      decoding="async"
      style={{display:"inline-block",verticalAlign:"middle",flex:"0 0 auto",objectFit:"contain",...style}}
    />
  );
}

export function CattleIcon({ size = 20, style = {}, title = "Rebanho" }){
  return <BovineHeadIcon size={Math.round(size * 1.05)} style={style} title={title} />;
}

export function renderInlineIcon(icon, { size = 16, title = "" } = {}){
  if (React.isValidElement(icon)) return icon;
  if (icon === "🐴") return <HorseIcon size={size} title={title || "Cavalo"} />;
  if (icon === "🐔") return <ChickenHeadIcon size={Math.round(size * 1.05)} title={title || "Avicultura"} />;
  if (icon === "🥣") return <TroughIcon size={Math.round(size * 1.05)} title={title || "Nutrição"} />;
  if (icon === "🐂" || icon === "🐄") return <BovineHeadIcon size={Math.round(size * 1.05)} title={title || "Bovino"} />;
  if (icon == null || icon === false) return null;
  return <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",lineHeight:1,fontSize:size}}>{icon}</span>;
}
